<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
    window.onload = function () {
        document.addEventListener('touchstart', function (event) {
            if (event.touches.length > 1) {
                event.preventDefault()
            }
        })
        document.addEventListener('gesturestart', function (event) {
            event.preventDefault()
        })
    }

    export default {
  name: 'App',
	provide(){
		return{
			reload:this.reload
		}
	},
	data(){
		return{
			isRouterAlive:true
		}
	},
	methods: {
		reload() {
			this.isRouterAlive=false
			this.$nextTick(function(){
				this.isRouterAlive=true
			})
		}
	}
}
</script>

<style>
  * {
    margin: 0;
    padding: 0;
    list-style: none;
    box-sizing: border-box;
    font-family: "Microsoft YaHei";
    font-weight: normal;
    border: 0;
    outline-style: none;
    text-decoration: none;
    font-style: normal;
    font-size: 26px;
  }

 

  img {
    display: block;
  }

  body {
    background: #f5f5f5;
    padding: 20px 0 118px 0;
    
  }

  html,body{ width: 100%; height: 100%; overflow: scroll;}
  html::-webkit-scrollbar, body::-webkit-scrollbar{width:0px;height:0px;}
  body{margin:0;}

  .header {
    width: 100%;
    height: 90px;
    padding: 0 36px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    box-shadow: 0 0 10px #ccc;
  }

  .header img {
    height: 40px;
  }

  .van-toast__text {
    margin-top: 30px;
  }

  .van-toast__icon {
    font-size: 60px;
    color: #333333;
  }

  .van-toast {
    width: 700px;
    height: 200px;
    line-height: 100px;
    background: #fff;
  }

  .van-toast__text {
    font-size: 30px;
    color: #333333;
  }

  .header h3 {
    font-size: 34px;
    line-height: 90px;
    width: 300px;
    text-align: center;
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -150px;
  }

  .btn {
    width: 80%;
    margin: 0 auto;
    height: 80px;
    display: block;
    font-size: 30px;
    color: #fff;
    border-radius: 45px;
  }

  .btn.btn-green {
    background: #05be8a;
  }

  .btn.btn-red {
    background: #ff0000;
  }

  .btn.btn-gray {
    background: #999999;
  }
  input[type=button], input[type=submit], input[type=file], button { cursor: pointer; -webkit-appearance: none; }
</style>



// WEBPACK FOOTER //
// src/App.vue